module.exports = __webpack_public_path__ + "img/mc.65ff9c0a.png";